import jquery from 'jquery';
import ajaxShop from '@/ajax/shop';

/**
 * @memberof Shop
 * @class
 * @alias Shop.client
 *
 * @description
 * Класс для работы с клиентом сайта
 */
var Client = function(_owner) {
  var self = this;

  self._owner = _owner;

  self._init();
};

/**
 * Инициализация
 * @method
 *
 * @private
 */
Client.prototype._init = function() {
  var self = this;
};

/**
 * Получение информации о посетителе
 * @method
 *
 * @return {jquery.ajax}
 *
 * @example
 * Shop.client.get()
 *    .done(function (result) { console.log(result) });
 */
Client.prototype.get = function() {
  var deferred = jquery.Deferred();

  ajaxShop.client.get()
    .done(function(result) {
      deferred.resolve(result);
    });

  return deferred.promise();
};

/**
 * @param {Object} options
 * @param {String} options.email
 * @param {String} options.password
 */
Client.prototype.login = function(options) {
  var self = this;

  return ajaxShop.client.login(options);
};

/**
 *
 */
Client.prototype.logout = function() {
  var self = this;

  return ajaxShop.client.logout();
};

export default Client;
